import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import service from '@/services'

Vue.use(Vuex)
const state = {
  projectOrderTable: [],
  scheduleTable: [],
  mediaTable: [],
  sysInfo: JSON.parse(window.localStorage.getItem('sysInfo') || '{}'),
  // 常量
  trackScale: 100,
  defaultPicWidth: 100,
  defaultPicHeight: 30,
  defaultTextHeight: 28,
  defaultDrrHeight: 70,
  // 当前操作数据
  list: null, // 当前操作的数组名
  vm: null, // 当前操作的this
  trackId: null, // 当前操作对应的轨道id
  trackIndex: null, // 当前操作的轨道块所属轨道index
  targetTrackIndex: null, // 当前操作对应的轨道index
  playingName: null, // 当前操作对应的playing-
  // 重要公用数据
  selected: { // 当前选择块的基本信息及对应元素
    index: null,
    trackIndex: null,
    type: null,
    target: null,
    width: null,
    dataURL: null,
    duration: null
  },
  selectedTarget: {}, // 当前选择块对应数据
  playingMaterial: {},
  playingPicture: [],
  playingPictureIndex: [],
  playingText: [],
  playingTextIndex: [],
  playingTransition: {},
  playingBackImage: [],
  playingBackImageIndex: [],
  // 指针数据
  pointerLeft: 0,
  pointerDuration: 0,
  // 轨道数据
  pictureTrackList: [[]],
  textTrackList: [[]],
  backImageTrackList: [[]],
  tracks: [
    {
      list: 'pictureTrackList',
      playing: 'playingPicture',
      drr: 'pictureDrr'
    },
    {
      list: 'textTrackList',
      playing: 'playingText',
      drr: 'textDrr'
    },
    {
      list: 'backImageTrackList',
      playing: 'playingBackImage',
      drr: 'backImageDrr'
    }
  ],
  // 拖拽数据
  dragTranslateX: 0,
  dragWidth: 0,
  dragIndex: null,
  direction: null,
  dragImage: new Image(),
  isDropZone: false,
  isDragFromTab: false,
  isDragging: false,
  isDragDrop: false,
  isConflic: false,
  isTrackDrag: false,
  dragPlayingName: null,
  picturePosition: {
    x: 0,
    y: 0
  },
  dragTarget: {},
  mouseElement: null,
  originalElement: null,
  // drr数据
  activeName: null,
  isPictureActive: false,
  isTextActive: false,
  isBackImageActive: false,
  tabResizedTarget: {
    width: 0,
    height: 0
  },
  // 其他操作数据
  isTrackResize: false,
  needPointerJudge: {
    isNeed: false,
    target: null
  },
  videoReource: [],
  selectedBackImageResource: [],
  selectedPictureResource: [],
  backZoom: {
    width: 1,
    height: 1
  },
  dmpUrl: '',
  unreadMessageNum: 0,
  showMessageTip: false
}

const getters = {
  getTextTrackList: state => state.textTrackList,
  getSelected: state => state.selected,
  unreadMessageNum: state => state.unreadMessageNum,
  showMessageTip: state => state.showMessageTip,
  sysInfo: state => state.sysInfo
}

const mutations = {
  saveProjectTable(state, data) {
    state.projectOrderTable = data
  },
  setDmpUrl(state, data) {
    state.dmpUrl = data
  },
  saveMediaTable(state, data) {
    state.mediaTable = data
  },
  setSysInfo(state, data) {
    state.sysInfo = data
    window.localStorage.setItem('sysInfo', JSON.stringify(data))
  },
  updatePointer(state, params) {
    state.pointerLeft = params.pointerLeft
    state.pointerDuration = params.pointerDuration
  },
  updatePlayingTarget(state, params) {
    if (params.index === undefined) {
      // 兼容未多轨道化的轨道数组
      state[params.target] = params.value
    } else {
      state[params.target] = params.value
      state[params.target + 'Index'] = params.index
    }
  },
  updateDrrActive(state, name) {
    state.activeName = name
  },
  updateDrrResolution(state, params) {
    state.tracks.forEach(item => {
      const list = state[item.list]
      for (let i = 0; i < list.length; i++) {
        // 对相关轨道值更新数值
        list[i].forEach(block => {
          block.nowXAxis = params.proportion * block.nowXAxis
          block.nowYAxis = params.proportion * block.nowYAxis
          block.width = params.proportion * block.width
          block.height = params.proportion * block.height
        })
        // 对正在显示范围的drr更新数值
        const target = state[item.playing][i]
        const resizableContainer = params.vm.$refs[item.drr][0].$refs.resizable
        if (!target || !resizableContainer) {
          return false
        }
        const resizable = resizableContainer[0]
        resizable.left = target.nowXAxis
        resizable.top = target.nowYAxis
        resizable.width = target.width
        resizable.height = target.height
      }
    })
  },
  isTrackResizeInvert(state) {
    // 选择块是否伸缩中
    state.isTrackResize = !state.isTrackResize
  },
  isNeedPointerJudging(state) {
    state.needPointerJudge.isNeed = false
    state.needPointerJudge.target = null
  },
  initDragImage(state) {
    state.dragImage.src = 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=='
  },
  initTrackListContainer(state, params) {
    for (let i = 0; i < params.list.length; i++) {
      state.list = params.list[i]
      state.vm = params.vm
      const nextParams = {
        data: params.data[i],
        videoFrame: params.videoFrame,
        videoInfo: params.videoInfo
      }
      this.commit('initTrackList', nextParams)
    }
    this.dispatch('setAllTrackDraw', params)
  },
  initTrackList(state, params) {
    // 暂时兼容接口未通
    if (!params.data) {
      return false
    }
    const list = JSON.parse(JSON.stringify(params.data))
    let realList = []
    if (state.list === 'pictureTrackList') {
      // 兼容未实现多轨道的贴图
      realList.push(list)
    } else {
      realList = list
    }
    for (let i = 0; i < realList.length; i++) {
      if (!realList[i]) {
        // 跳过无值轨道数据
        continue
      }
      realList[i].forEach(item => {
        const wnh = item.zoom.split(':')
        const widthScale = params.videoFrame.width / params.videoInfo.firstVideoH
        const heightScale = params.videoFrame.height / params.videoInfo.firstVideoV
        item.width = wnh[0] * 1
        item.height = wnh[1] * 1
        item.duration = item.endSecond - item.startSecond
        item.range = item.duration * state.trackScale
        item.realRange = item.duration * state.trackScale
        item.trackStartTime = item.startSecond
        item.trackEndTime = item.endSecond
        item.positionXBegin = item.startSecond * state.trackScale
        item.positionXEnd = item.endSecond * state.trackScale
        item.nowXAxis = widthScale * item.xAxis
        item.nowYAxis = heightScale * item.yAxis
        item.scale = 1
        item.transparency = item.transparency * 1
        // 贴图的特殊属性处理
        if (state.list === 'pictureTrackList') {
          item.fileUrl = item.watermark
          item.transparency = item.transparency * 1
          if (!item.overturn) {
            item.transform = ''
          } else {
            item.transform = item.overturn === 'vflip' ? 'rotateX(180deg)' : 'rotateY(180deg)'
          }
        }
        // 字幕的特殊属性处理
        if (state.list === 'textTrackList') {
          item.fontWeight = item.bold ? 600 : 400
          item.fontStyle = item.italic ? 'italic' : 'normal'
          item.border = item.frame ? 'solid 1px #FFFFFF' : 'none'
          item.textShadow = item.shadowY ? '0px 1.5px #000000' : 'none'
          item.textDecoration = item.underLine ? 'underline' : 'none'
          item.webkitTextStroke = item.borderW ? '1px #000000' : '0px'
        }
      })
      if (i === 0) {
        // 删掉初始化用的第一个空数组
        state[state.list].pop()
      }
      state[state.list].push(realList[i])
    }
  },
  clearSelected(state) {
    // 清空选择块数据
    for (let item in state.selected) {
      state.selected[item] = null
    }
    state.selectedTarget = {}
  },
  clearPlaying(state, params) {
    state[params.target][params.trackIndex] = undefined
    state[params.target + 'Index'][params.trackIndex] = -1
  },
  clearAll(state) {
    state.textTrackList = [[]]
    state.pictureTrackList = [[]]
    state.backImageTrackList = [[]]
    state.pointerLeft = 0
    state.pointerDuration = 0
    state.videoReource = []
    state.selectedBackImageResource = []
    state.selectedPictureResource = []
    // console.log('清理缓存')
  },
  trackBlockSelect(state, params) {
    // 消除原选择块的boxShadow
    if (state.selected.target) {
      state.selected.target.style.boxShadow = ''
    }
    const realTarget = params.e.target ? params.e.target : params.e
    state.selected.index = params.index
    state.selected.trackIndex = isNaN(params.trackIndex) ? null : params.trackIndex
    state.selected.type = params.list
    state.selected.target = realTarget
    state.selected.width = realTarget.offsetWidth
    state.selected.dataURL = realTarget.style ? realTarget.style.backgroundImage : ''
    state.targetTrackIndex = state.selected.trackIndex
    realTarget.style.boxShadow = 'inset 0px 0px 1px 3px #409eff'
    // 暂时兼容未使用vuex的视频素材轨道
    if (params.list === 'videoTrackList') {
      state.selectedTarget = state.videoReource[params.trackIndex][params.index]
    } else {
      const realObject = params.realList ? params.realList[params.index] : state[params.list][params.trackIndex][params.index]
      state.selectedTarget = realObject
    }
  },
  trackBlockResize(state, params) {
    state.list = params.list
    state.vm = params.vm
    state.prefix = params.prefix
    state.trackId = params.prefix + 'Track'

    const index = state.selected.index
    const target = state[params.list][state.selected.trackIndex][index]
    const newWidth = params.newWidth
    const nextToTarget = state[params.list][state.selected.trackIndex][index + 1]
    const originalWidth = params.element.clientWidth
    let rangeLimit = target.fileType === 'video' ? target.range : -1
    let realRange = newWidth
    if (rangeLimit === -1) {
      // 非视频贴图块 - 可无限伸缩
      target.positionXEnd = target.positionXBegin + newWidth
    } else {
      // 视频贴图受本身视频长度限制 有最大拉伸值
      const realWidth = rangeLimit >= newWidth ? newWidth : rangeLimit
      target.positionXEnd = target.positionXBegin + realWidth
      realRange = realWidth
    }
    target.realRange = (target.positionXEnd - target.positionXBegin).toFixed(1) * 1
    params.element.style.width = realRange + 'px'
    // 选择块位置在最末时 伸缩对其他块无影响 无需后续操作
    if (!nextToTarget) {
      return true
    }
    // 当选择块拉长 且改变的长度大于两选择块之间的距离 则后块需要后移
    const changeWidth = realRange - originalWidth
    if (realRange > originalWidth && changeWidth > (nextToTarget.positionXBegin - target.positionXEnd)) {
      this.commit('trackBlockResizeMove', changeWidth)
    }
  },
  trackBlockResizeMove(state, changeWidth) {
    // 轨道块伸长 所在间隔不够时 后移
    let list = state[state.list][state.selected.trackIndex]
    for (let i = state.selected.index + 1; i < list.length; i++) {
      list[i].positionXBegin += changeWidth
      list[i].positionXEnd += changeWidth
    }
    state.isTrackResize = true
    // this.dispatch('setTrackDraw', false)
    this.commit('trackDraw')
  },
  trackBlockDelete(state, params) {
    state.vm = params.vm
    state.list = state.selected.type
    state.prefix = params.prefix
    state.trackId = params.trackId

    let list = state[state.selected.type][state.selected.trackIndex]
    const index = state.selected.index
    // 当前轨道为空时 不操作
    if (!list.length) {
      return false
    }
    // 删除所选轨道块
    list.splice(index, 1)
    list.forEach((item, index) => {
      item.seq = index + 1
    })
    if (!list.length) {
      // 当前轨道删减后为空 清除选中及各种状态
      this.commit('clearSelected')
      return true
    }
    // 当前轨道还有块时 选中定位到旁边块
    this.dispatch('setNextTrackBlock')
  },
  dragStart(state, params) {
    const e = params.e
    const item = params.item
    const index = params.index

    e.dataTransfer.setData('Text', index)
    // 用全透明图片替换掉默认的半透明图片
    e.dataTransfer.setDragImage(state.dragImage, 0, 0)

    state.isTrackDrag = params.isTrackDrag
    state.prefix = params.prefix
    state.list = params.list
    state.trackId = params.trackId
    state.dragTarget = item
    state.isDropZone = false
    state.isDragDrop = false
    state.isDragging = true

    const positionRect = e.target.getBoundingClientRect()
    if (state.isTrackDrag) {
      // 当前为轨道dragStart时
      state.originalElement = e.target
      state.picturePosition.y = positionRect.top
      state.isDragFromTab = false
      state.trackIndex = params.trackIndex
      state.dragIndex = index
      const playingName = 'playing' + state.prefix.slice(0, 1).toUpperCase() + state.prefix.slice(1)
      if (state[playingName][state.trackIndex] && state[playingName][state.trackIndex].seq === index + 1) {
        state.dragPlayingName = state.prefix
      }
    } else {
      // 当前为tabs标签页dragStart时
      state.isDragFromTab = true
      state.trackIndex = null
      state.dragIndex = null
    }

    // 设置跟随鼠标的元素及样式
    state.mouseElement = document.createElement('DIV')
    state.dragTranslateX = positionRect.left

    if (!item.duration) {
      state.dragWidth = state.defaultPicWidth
    } else {
      state.dragWidth = item.realRange ? item.realRange : item.duration * 100
    }

    state.mouseElement.style = 'position: fixed; top: 0px; left: 0px; z-index: 9999; pointer-events: none; background-size: auto 100%; border-radius: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'
    state.mouseElement.style.width = state.dragWidth + 'px'
    state.mouseElement.style.transform = 'translate(' + positionRect.left + 'px,' + positionRect.top + 'px)'
    if (state.prefix === 'picture' || state.prefix === 'backImage') {
      state.mouseElement.style.height = state.defaultPicHeight + 'px'
      state.mouseElement.style.backgroundImage = 'url(' + item.resourceUrl + ')'
      state.mouseElement.style.backgroundColor = '#000000'
    }
    if (state.prefix === 'text') {
      state.mouseElement.innerText = item.text
      state.mouseElement.style.fontSize = '13px'
      state.mouseElement.style.height = state.defaultTextHeight + 'px'
      state.mouseElement.style.lineHeight = state.defaultTextHeight + 'px'
      state.mouseElement.style.backgroundColor = '#F2F2F2'
      state.mouseElement.style.textAlign = 'center'
      state.mouseElement.style.boxShadow = '#ccc 0px 0px 1px 1px inset'
      state.mouseElement.style.color = '#333333'
    }
    // 添加元素到DOM
    document.body.appendChild(state.mouseElement)
  },
  tabDragging(state, e) {
    e.preventDefault()
    // 获取拖拽移动方向及当前鼠标位置
    state.direction = e.clientX - state.dragTranslateX
    state.dragTranslateX = e.clientX
    // 在dropZone外拖拽时 元素位置即鼠标位置
    if (!state.isDropZone) {
      state.mouseElement.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)'
    }
  },
  trackDragging(state, e) {
    // 获取拖拽移动方向及当前鼠标位置
    state.direction = e.clientX - state.dragTranslateX
    state.dragTranslateX = e.clientX
    // 隐藏轨道上的拖拽目标
    state.originalElement.style.visibility = 'hidden'
  },
  dragTrackEnter(state, e) {
    // 须在对应轨道类型操作
    if (e.target.className !== state.trackId) {
      return false
    }
    // 获取对应的轨道index 5为Track字符串的长度
    const index = e.target.id.indexOf('Track')
    state.targetTrackIndex = e.target.id.slice(index + 5) * 1
    // 拖拽元素进入dropZone 添加boxShadow
    let target = state.mouseElement
    target.style.boxShadow = 'inset 0px 0px 1px 3px #409eff'
  },
  dragTrackOver(state, params) {
    // 须在对应轨道操作
    if (params.e.target.className !== state.trackId) {
      return false
    }
    params.e.preventDefault()
    state.vm = params.vm
    state.isDropZone = true
    this.commit('draggingMove')
  },
  draggingMove(state) {
    const track = document.getElementById(state.trackId + state.targetTrackIndex)
    const trackPosition = track.getBoundingClientRect()
    const iconWidth = trackPosition.left
    const dragWidth = state.dragWidth
    const element = state.mouseElement
    // 需减去左侧图标列表的宽度 获得轨道贴图块真正x坐标
    const dragTranslateX = state.dragTranslateX
    const realX = (dragTranslateX - iconWidth).toFixed(1) * 1
    const endX = (realX + dragWidth).toFixed(1) * 1
    const list = state[state.list][state.targetTrackIndex]
    state.iconWidth = iconWidth
    state.picturePosition.y = trackPosition.top

    let targetOne = null // 当前块 与拖拽块产生冲突的轨道块
    let targetTwo = null // 比较块 用于计算与当前块的间隔
    let targetRange = null // 当前块与比较块的间隔
    let lengthCompare = null // targetRange与拖拽块长度的比较
    let realWidth = null // 拖拽块的新宽度
    let newTranslateX = null // 拖拽块的新x坐标
    let canMove = false // 冲突下是否可以产生移动
    // 判断鼠标在不在 轨道块,若在 得出index
    const indexOnBlock = list.findIndex((item, index) => {
      const rightOne = endX >= item.positionXBegin && endX <= item.positionXEnd
      const leftOne = realX >= item.positionXBegin && realX <= item.positionXEnd
      const rightTwo = item.positionXBegin >= realX && item.positionXBegin <= endX
      const leftTwo = item.positionXEnd >= realX && item.positionXEnd <= endX
      const targetIndex = state.targetTrackIndex === state.trackIndex ? index !== state.dragIndex : 1
      return targetIndex && (rightOne || leftOne || rightTwo || leftTwo)
    })
    // 鼠标在轨道块 获取当前块与比较块 得到块间隔
    if (indexOnBlock !== -1) {
      targetOne = list[indexOnBlock]
      if (state.direction >= 0) {
        targetTwo = (state.targetTrackIndex === state.trackIndex && indexOnBlock + 1 !== state.dragIndex) || state.targetTrackIndex !== state.trackIndex ? list[indexOnBlock + 1] : list[indexOnBlock + 2]
        canMove = realX >= targetOne.positionXBegin + targetOne.realRange / 2
      } else {
        targetTwo = (state.targetTrackIndex === state.trackIndex && indexOnBlock - 1 !== state.dragIndex) || state.targetTrackIndex !== state.trackIndex ? list[indexOnBlock - 1] : list[indexOnBlock - 2]
        canMove = realX <= targetOne.positionXBegin + targetOne.realRange / 2
      }
      if (state.direction === 0) {
        canMove = true
      }
      if (state.isDragFromTab && !canMove) {
        element.style.transform = 'translate(' + dragTranslateX + 'px,' + state.picturePosition.y + 'px)'
      }
      // 比较块undefined时
      if (!targetTwo) {
        // 鼠标在轨道块 且 下一个块undefined -> 当前比较块为最末
        if (state.direction > 0 && canMove) {
          // console.log('鼠标在轨道块 且 下一个块undefined -> 当前比较块为最末')
          newTranslateX = targetOne.positionXEnd + iconWidth
          element.style.transform = 'translate(' + newTranslateX + 'px,' + state.picturePosition.y + 'px)'
          return true
        }
        if (state.direction < 0 && canMove) {
          // 鼠标在轨道块 且 上一个块undefined -> 当前比较块为最前
          if (targetOne.positionXBegin < 5) {
            // console.log('鼠标在轨道块 且 上一个块undefined -> 当前比较块为最前 原长度挤')
            // this.handleTranslateChange(indexOnBlock, list.length - 1, true, dragWidth)
            // element.style.transform = 'translate(' + iconWidth + 'px,' + state.picturePosition.y + 'px)'
            return true
          }
          lengthCompare = targetOne.positionXBegin - dragWidth
          realWidth = lengthCompare > 0 ? dragWidth : targetOne.positionXBegin
          newTranslateX = targetOne.positionXBegin - realWidth + iconWidth
          state.dragWidth = realWidth
          element.style.width = realWidth + 'px'
          element.style.transform = 'translate(' + newTranslateX + 'px,' + state.picturePosition.y + 'px)'
          // console.log('鼠标在轨道块 且 上一个块undefined -> 当前比较块为最前 改长度放')
          return true
        }
      } else {
        // 比较块存在时
        targetRange = state.direction >= 0 ? targetTwo.positionXBegin - targetOne.positionXEnd : targetOne.positionXBegin - targetTwo.positionXEnd
        if (targetRange < 5) {
          // console.log('鼠标在轨道块 块间隔不够 原长度挤')
          // this.handleTranslateChange(indexOnBlock, list.length - 1, true, dragWidth)
          // element.style.transform = 'translate(' + (targetOne.positionXEnd + iconWidth) + 'px,' + state.picturePosition.y + 'px)'
          return true
        }
        lengthCompare = targetRange - dragWidth
        if (state.direction > 0 && canMove) {
          realWidth = lengthCompare > 0 ? dragWidth : targetRange
          newTranslateX = targetOne.positionXEnd + iconWidth
          state.dragWidth = realWidth
          element.style.width = realWidth + 'px'
          element.style.transform = 'translate(' + newTranslateX + 'px,' + state.picturePosition.y + 'px)'
          // console.log('鼠标在轨道块 块间隔够 方向为右 改长度放')
          return true
        }
        if (state.direction < 0 && canMove) {
          realWidth = lengthCompare > 0 ? dragWidth : targetRange
          newTranslateX = targetOne.positionXBegin - realWidth + iconWidth
          state.dragWidth = realWidth
          element.style.width = realWidth + 'px'
          element.style.transform = 'translate(' + newTranslateX + 'px,' + state.picturePosition.y + 'px)'
          // console.log('鼠标在轨道块 块间隔够 方向为左 改长度放')
          return true
        }
      }
    }
    if (indexOnBlock === -1) {
      element.style.transform = 'translate(' + dragTranslateX + 'px,' + state.picturePosition.y + 'px)'
    }
  },
  drop(state, e) {
    e.preventDefault()
    state.isDropZone = false
    state.isDragDrop = true
    state.isDragging = false
    const target = Object.assign({}, state.dragTarget)
    const positionRect = state.mouseElement.getBoundingClientRect()
    // 设置当前拖拽块的新坐标
    target.positionXBegin = state.prefix === 'backImage' ? 0 : positionRect.left - state.iconWidth
    target.positionXEnd = target.positionXBegin + positionRect.width
    if (state.isDragFromTab) {
      state.isDragFromTab = false
    }
    // 不允许重叠放置
    this.commit('judgeConflicBlock', target)
    if (state.isConflic) {
      state.vm.$message({
        type: 'warning',
        message: '该区域空位长度不够，不支持直接放置'
      })
      document.body.removeChild(state.mouseElement)
      state.originalElement.style.visibility = 'visible'
      state.mouseElement = null
      return true
    }
    // 重新获得playing-
    state.needPointerJudge.isNeed = true
    state.needPointerJudge.target = state.list
    if (state.isTrackDrag) {
      state.originalElement.style.visibility = 'visible'
      state.isTrackDrag = false
      state.dragPlayingName = null
      this.commit('trackDragRealEnd', { target: target, index: e.dataTransfer.getData('Text') })
    } else {
      state.dragTarget = {}
      this.commit('tabDragAdd', { target: target, index: undefined })
    }
  },
  tabDragAdd(state, params) {
    for (let key in params) {
      state[key] = params[key]
    }
    const target = params.target
    if (!target.duration) {
      target.duration = state.defaultPicWidth / state.trackScale
    }
    target.range = (target.duration * state.trackScale).toFixed(1) * 1
    target.realRange = target.range
    // target.width = state.defaultPicWidth
    target.nowXAxis = 0
    target.nowYAxis = 0
    target.whirl = 0
    target.scale = 1
    target.transparency = 1
    if (state.list === 'pictureTrackList' || state.list === 'backImageTrackList') {
      target.overturn = ''
    }
    state.tempDragTarget = target
    if (state.list === 'pictureTrackList' || state.list === 'backImageTrackList') {
      // 贴图需要根据原图比例设置显示宽高
      this.dispatch('getWidthAndHeight', params.index)
    } else {
      this.commit('tabDragRealAdd', {
        wnh: {
          width: state.defaultPicWidth,
          height: state.defaultDrrHeight
        },
        index: params.index
      })
    }
  },
  tabDragRealAdd(state, parmas) {
    if (state.prefix === 'picture') {
      state.tempDragTarget.width = state.tempDragTarget.width / state.backZoom.width
      state.tempDragTarget.height = state.tempDragTarget.height / state.backZoom.height
    }
    // state.tempDragTarget.height = state.tempDragTarget.width / parmas.wnh.width * parmas.wnh.height
    // state.tempDragTarget.zoom = state.tempDragTarget.width + ':' + state.tempDragTarget.height
    // 特殊处理背景图，只能有一张背景图
    if (state.prefix === 'backImage') {
      state[state.list][state.targetTrackIndex][0] = state.tempDragTarget
      this.commit('listSort')
      this.commit('listMove', {
        target: state.tempDragTarget,
        index: 0
      })
    } else {
      if (isNaN(parmas.index)) {
        // 不定添加位置的轨道块
        state[state.list][state.targetTrackIndex].push(state.tempDragTarget)
        this.commit('listSort')
      } else {
        // 指定添加位置的轨道块
        state[state.list][state.targetTrackIndex].splice(parmas.index + 1, 0, state.tempDragTarget)
        this.commit('listMove', {
          target: state.tempDragTarget,
          index: parmas.index + 1
        })
      }
    }
  },
  listSort(state) {
    // 按照在轨时间先后进行排序
    state[state.list][state.targetTrackIndex].sort((item, nextItem) => {
      return item.positionXBegin - nextItem.positionXBegin
    })
    this.commit('getList')
  },
  getList(state) {
    this.commit('formatList', state.targetTrackIndex)
    if (state.trackIndex !== null && state.targetTrackIndex !== state.trackIndex) {
      this.commit('formatList', state.trackIndex)
      this.dispatch('setTrackDraw', true)
    } else {
      this.dispatch('setTrackDraw', false)
    }
  },
  formatList(state, listIndex) {
    // 更新轨道数据
    const scale = state.trackScale
    state[state.list][listIndex].forEach((item, index) => {
      item.positionXBegin = (item.positionXBegin).toFixed(1) * 1
      item.positionXEnd = (item.positionXEnd).toFixed(1) * 1
      item.realRange = (item.positionXEnd - item.positionXBegin).toFixed(1) * 1
      item.trackStartTime = (item.positionXBegin / scale).toFixed(1) * 1
      item.trackEndTime = (item.positionXEnd / scale).toFixed(1) * 1
      item.startSecond = item.trackStartTime
      item.endSecond = item.trackEndTime
      item.seq = index + 1
    })
  },
  listMove(state, params) {
    const index = params.index
    const list = state[state.list][state.targetTrackIndex]
    const length = list.length
    const moveLength = params.target.realRange
    const newBeginX = list[index].positionXBegin
    const newEndX = list[index].positionXEnd
    const nextBeginX = list[index + 1] ? list[index + 1].positionXBegin : undefined
    const newWidth = nextBeginX - newBeginX
    // 指针与后一个贴图块的间隔 - 够放新贴图块 直接放
    if (!nextBeginX || nextBeginX >= newEndX) {
      this.commit('getList')
      return true
    }
    // 指针与后一个贴图块的间隔 - 以5px为基准, 不完全够放新贴图块 改变新贴图块长度
    if (newWidth >= 5) {
      list[index].positionXEnd = nextBeginX
      this.commit('getList')
      return true
    }
    // 指针与后一个贴图块的间隔 - 不够放新贴图块 后面的贴图块后移挪位
    for (let i = index + 1; i < length; i++) {
      list[i].positionXBegin += moveLength
      list[i].positionXEnd += moveLength
    }
    this.commit('getList')
  },
  judgeConflicBlock(state, target) {
    const beginX = (target.positionXBegin).toFixed(1) * 1
    const endX = (target.positionXEnd).toFixed(1) * 1
    // 判断所在位置是否已有块
    const coverIndex = state[state.list][state.targetTrackIndex].findIndex((item, index) => {
      const track = state.targetTrackIndex === state.trackIndex ? state.dragIndex !== index : true
      return track && ((beginX > item.positionXBegin && beginX < item.positionXEnd) || (endX > item.positionXBegin && endX < item.positionXEnd))
    })
    const containIndex = state[state.list][state.targetTrackIndex].findIndex((item, index) => {
      const track = state.targetTrackIndex === state.trackIndex ? state.dragIndex !== index : true
      return track && (beginX < item.positionXBegin && endX > item.positionXEnd)
    })
    if (coverIndex !== -1 || containIndex !== -1) {
      state.isConflic = true
    } else {
      state.isConflic = false
    }
  },
  tabDragEnd(state, e) {
    // 拖拽元素已在dropZone 但鼠标在dropZone外松开时 也要放元素
    if (state.isDropZone) {
      this.commit('drop', e)
    }
    // 清空拖拽元素
    if (state.mouseElement) {
      document.body.removeChild(state.mouseElement)
      state.mouseElement = null
    }
  },
  trackDragEnd(state) {
    state.isDragging = false
    state.isDropZone = false
    // 已在dropZone内松开并放置 无需后续处理
    if (state.isDragDrop) {
      return true
    }
    // 未在dropZone内松开并放置时
    const target = Object.assign({}, state.dragTarget)
    const positionRect = state.mouseElement.getBoundingClientRect()
    target.positionXBegin = positionRect.left - state.iconWidth
    target.positionXEnd = target.positionXBegin + positionRect.width
    // 判断是否进入指针区域
    if (state.pointerLeft >= target.positionXBegin && state.pointerLeft <= target.positionXEnd) {
      state.needPointerJudge.isNeed = true
      state.needPointerJudge.target = state.list
    }
    this.commit('trackDragRealEnd', { target: target, index: state.dragIndex })
    state.isTrackDrag = false
    state.dragPlayingName = null
    state.originalElement.style.visibility = 'visible'
  },
  trackDragRealEnd(state, params) {
    const target = params.target
    const index = params.index * 1
    let list = state[state.list][state.trackIndex]
    // 清空拖拽元素
    if (state.mouseElement) {
      document.body.removeChild(state.mouseElement)
    }
    list[index].positionXBegin = target.positionXBegin
    list[index].positionXEnd = target.positionXEnd
    list[index].isSelected = true
    if (state.targetTrackIndex !== state.trackIndex) {
      state[state.list][state.targetTrackIndex].push(list[index])
      state[state.list][state.trackIndex].splice(index, 1)
    }
    state.dragTranslateX = null
    state.dragWidth = null
    state.mouseElement = null
    state.dragIndex = null
    // 更新数据后需重新排序
    this.commit('listSort')
  },
  trackDraw(state, paramsIndex) {
    if (!isNaN(paramsIndex)) {
      state.targetTrackIndex = paramsIndex
    }
    // 画轨道块
    const list = state[state.list][state.targetTrackIndex]
    for (let i = 0; i < list.length; i++) {
      // 获取当前操作的ref名
      const index = state.prefix + i

      const targetPicture = list[i]
      let targetElement = null
      // 根据this设置获取路径
      if (state.vm.$el.id === 'onlineClip') {
        targetElement = state.vm.$refs[state.trackId][state.targetTrackIndex].$refs[index][0]
      } else {
        targetElement = document.querySelector('#' + state.trackId + state.targetTrackIndex).querySelector('#' + index)
        // targetElement = state.vm.$refs[index][0]
      }
      if (state.isTrackDrag || state.isTrackResize) {
        // 只是移动 其他样式无需改变
        targetElement.style.transform = 'translateX(' + targetPicture.positionXBegin + 'px)'
      } else {
        targetElement.style.width = state.prefix === 'backImage' ? '6000px' : targetPicture.realRange + 'px'
        targetElement.style.backgroundSize = 'auto 100%'
        targetElement.style.transform = 'translateX(' + targetPicture.positionXBegin + 'px)'
        if (state.prefix === 'picture' || state.prefix === 'backImage') {
          targetElement.style.height = state.defaultPicHeight + 'px'
          targetElement.style.backgroundImage = 'url(' + targetPicture.resourceUrl + ')'
          targetElement.style.backgroundColor = '#000'
        }
        if (state.prefix === 'text') {
          targetElement.style.background = '#f2f2f2'
          targetElement.style.height = state.defaultTextHeight + 'px'
        }
      }
    }
  },
  trackAdd(state, params) {
    state[params.name + 'TrackList'].splice(params.index + 1, 0, [])
    this.commit('trackAfter', params)
  },
  trackDelete(state, params) {
    state[params.name + 'TrackList'].splice(params.index, 1)
    this.commit('trackAfter', params)
  },
  trackCopy(state, params) {
    const addTarget = JSON.parse(JSON.stringify(state[params.name + 'TrackList'][params.index]))
    state[params.name + 'TrackList'].splice(params.index + 1, 0, addTarget)
    this.commit('trackAfter', params)
  },
  trackAfter(state, params) {
    state.list = params.list
    state.targetTrackIndex = params.index
    state.vm = params.vm
    state.prefix = params.name
    state.trackId = params.name + 'Track'
    this.dispatch('setTrackDraw', true)
  },
  drrActive(state, params) {
    state.activeName = params.activeTarget
    state.list = params.list
    state.playingName = params.playingName
    state.vm = params.vm
  },
  drrDragStop(state, params) {
    const resizable = params.vm.$refs.resizable[0] || params.vm.$refs.resizable
    let target = state.selectedTarget
    state.vm = params.vm
    target.nowXAxis = params.left
    target.nowYAxis = params.top
    target.width = resizable.width
    target.height = resizable.height
  },
  drrResizing(state, params) {
    const rect = params.rect
    const resizable = params.vm.$refs.resizable[0] || params.vm.$refs.resizable
    state.vm = params.vm
    if (params.keyCode === 16) {
      const target = state.selectedTarget
      const widthRange = rect.width - target.width
      const heightRange = rect.height - target.height
      if (rect.left !== target.nowXAxis || rect.top !== target.nowYAxis) {
        resizable.left = target.nowXAxis
        resizable.elmX = target.nowXAxis
        resizable.top = target.nowYAxis
        resizable.elmY = target.nowYAxis
      }
      if (widthRange > heightRange) {
        resizable.height = rect.width / target.width * target.height
        resizable.elmH = rect.width / target.width * target.height
      } else {
        resizable.width = rect.height / target.height * target.width
        resizable.elmW = rect.height / target.height * target.width
      }
      return true
    }
    resizable.elmW = rect.width
    resizable.elmH = rect.height
  },
  drrResizeStop(state, params) {
    let selectedTarget = state.selectedTarget
    selectedTarget.nowXAxis = params.left
    selectedTarget.nowYAxis = params.top
    selectedTarget.width = params.width
    selectedTarget.height = params.height
    selectedTarget.zoom = params.width + ':' + params.height
    if (params.type) {
      this.commit('drrElementData', { way: true, index: state.selected.trackIndex, type: 'video' })
    } else {
      this.commit('drrElementData', { way: true, index: state.selected.trackIndex })
    }
  },
  drrRotating(state, params) {
    if (params.type) { // 视频特殊处理
      state.selectedTarget.whirl = params.angle
      state.videoReource[0].whirl = params.angle
    } else {
      state.selectedTarget.whirl = params.angle
      state[state.list][state.selected.trackIndex][state.selectedTarget.seq - 1].whirl = params.angle
    }
  },
  drrTextChange(state, params) {
    state.textTrackList[params.trackIndex][params.index].text = params.text
  },
  drrElementData(state, params) {
    if (!params.way) {
      state.vm = params.vm
      state.playingName = params.playingName
    }
    if (!params.type) {
      if (!state[state.playingName][params.index] || !state.vm.$refs.resizable || !state.vm.$refs.drrTarget) {
        return false
      }
    }
    const resizable = state.vm.$refs.resizable[0]
    const drrTarget = state.vm.$refs.drrTarget[0]
    const target = params.type ? state.selectedTarget : state[state.playingName][params.index]
    if (!resizable || !drrTarget) {
      return false
    }
    resizable.elmW = target.width
    resizable.elmH = target.height
    resizable.width = target.width
    resizable.height = target.height
    resizable.rotateAngle = target.whirl
    resizable.elmX = target.nowXAxis
    resizable.elmY = target.nowYAxis
    resizable.left = target.nowXAxis
    resizable.top = target.nowYAxis
    const targetStyle = drrTarget.$el ? drrTarget.$el.style : drrTarget.style
    targetStyle.transform = target.transform
    targetStyle.opacity = target.transparency
  },
  drrTabRotate(state, angle) {
    const resizable = state.vm.$refs.resizable[0]
    let selectedTarget = state.selectedTarget
    let listTarget = state[state.list][state.selected.trackIndex][state.selectedTarget.seq - 1]

    resizable.rotateAngle = angle
    selectedTarget.whirl = angle
    // 同步更新数组内的数据
    listTarget.whirl = angle
  },
  drrTabBeforeResize(state, lastZoom) {
    // 得到当前缩放比例下贴图的实际大小(即缩放1倍时)
    const resizable = state.vm.$refs.resizable[0]
    const beforeWidth = resizable.width
    const beforeHeight = resizable.height

    // 缩放滑块设为0时 不做事前计算
    if (lastZoom !== 0) {
      state.tabResizedTarget.width = beforeWidth / lastZoom
      state.tabResizedTarget.height = beforeHeight / lastZoom
    }
  },
  drrTabResize(state, zoom) {
    let selectedTarget = state.selectedTarget
    // 缩放为0时 需要进行特殊处理 否则drr组件报错
    selectedTarget.width = state.tabResizedTarget.width * zoom === 0 ? 1 : state.tabResizedTarget.width * zoom
    selectedTarget.height = state.tabResizedTarget.height * zoom === 0 ? 1 : state.tabResizedTarget.width * zoom
    selectedTarget.scale = zoom
    // 获取现在的宽高比
    selectedTarget.zoom = selectedTarget.width + ':' + selectedTarget.height

    this.commit('drrElementData', { way: true, index: state.selected.trackIndex })
  },
  drrTabOpacity(state, opacity) {
    const realTarget = state.vm.$refs.drrTarget ? state.vm.$refs.drrTarget[0] : null
    if (!realTarget) {
      return false
    }
    const targetStyle = realTarget.$el ? realTarget.$el.style : realTarget.style
    targetStyle.opacity = opacity

    let selectedTarget = state.selectedTarget
    selectedTarget.transparency = opacity
  },
  drrTabFlip(state, way) {
    const realTarget = state.vm.$refs.drrTarget ? state.vm.$refs.drrTarget[0] : null
    if (!realTarget) {
      return false
    }
    const targetStyle = realTarget.$el ? realTarget.$el.style : realTarget.style
    const targetOne = 'rotate' + way + '(180deg)' // 对应使用way方向的翻转
    const targetTwo = 'rotate' + way + '(0deg)' // 对应取消way方向的翻转
    const transform = targetStyle.transform

    // 初次设置翻转 对应使用way方向的翻转
    if (!transform) {
      targetStyle.transform = targetOne
      this.commit('drrTabFlipEnd', { transform: targetOne, way: way })
      return true
    }
    // 非初次设置翻转 需知道前次翻转是不是当前方向
    const existWay = transform.indexOf(way)
    // 非初次设置翻转 且不是当前方向 累加transform
    if (existWay === -1) {
      targetStyle.transform += targetOne
      this.commit('drrTabFlipEnd', { transform: targetStyle.transform, way: way })
      return true
    }
    // 非初次设置翻转 且为当前方向 则需知道上次是使用还是取消
    const exist = transform.indexOf(targetOne)
    // 对应处理
    if (exist !== -1) {
      targetStyle.transform = transform.replace(targetOne, targetTwo)
    } else {
      targetStyle.transform = transform.replace(targetTwo, targetOne)
    }
    this.commit('drrTabFlipEnd', { transform: targetStyle.transform, way: way })
  },
  drrTabFlipEnd(state, params) {
    let selectedTarget = state.selectedTarget
    selectedTarget.transform = params.transform
    // 根据当前翻转内容 设置规范的存值
    if (params.transform.indexOf('180') === -1) {
      selectedTarget.overturn = ''
    } else {
      selectedTarget.overturn = params.way === 'X' ? 'vflip' : 'hflip'
    }
  },
  drrTabFontOperation(state, params) {
    // 处理字幕操作标签页 无需分隔样式名的操作
    // 找到正在操作的drr 更新样式 更新数值
    const target = document.querySelector('#textDrr' + state.selected.trackIndex).querySelector('.drr-target')
    if (target) {
      const targetStyle = target.style
      targetStyle[params.styleName] = params.isNeedPx ? params.styleValue + 'px' : params.styleValue
      state.textTrackList[state.selected.trackIndex][state.selected.index][params.styleName] = params.styleValue
    }
  },
  drrTabFontStyle(state, params) {
    // 处理字幕操作标签页 需要分隔样式名的操作
    // 找到正在操作的drr 更新样式 更新数值
    const target = document.querySelector('#textDrr' + state.selected.trackIndex).querySelector('.drr-target')
    if (target) {
      const targetStyle = target.style
      targetStyle[params.styleName] = params.styleValue
      if (!params.isOnly) {
        state.textTrackList[state.selected.trackIndex][state.selected.index][params.styleName] = params.styleValue
      }
      state.textTrackList[state.selected.trackIndex][state.selected.index][params.name] = params.value
    }
  },
  setVideoReource(state, params) {
    state.videoReource = []
    state.videoReource.push(params)
  },
  // 从历史背景中选择到操作区
  setBackIamgeResource(state, parmas) {
    state.selectedBackImageResource = []
    state.selectedBackImageResource.push(parmas)
  },
  // 删除操作区背景
  deletBackIamgeResource(state, index) {
    state.selectedBackImageResource.splice(index, 1)
    state.backImageTrackList = [[]]
  },
  // 从历史贴图中选择到操作区
  setPictureResource(state, params) {
    state.selectedPictureResource.push(params)
  },
  deletPictureResource(state, params) {
    const index = params.index
    const num = params.num
    // // 需要获取轨道上有那些用到当前贴图的，需要清空
    // state.pictureTrackList.forEach(item => {
    //   item.forEach((e, i) => {
    //     if (e.md5 === state.selectedPictureResource[index].md5) {
    //       console.log('111')
    //       item.splice(i, 1)
    //     }
    //   })
    // })
    state.selectedPictureResource.splice(index, num)
    // 当前轨道还有块时 选中定位到旁边块
  },
  // 缩放比
  setZoom(state, params) {
    state.backZoom.width = params.realWidth / params.width
    state.backZoom.height = params.realHeight / params.height
  },
  SET_UNREAD_MSG_NUM(state, num) {
    state.unreadMessageNum = num
  },
  SET_MESSAGE_TIP(state, isShow) {
    state.showMessageTip = isShow
  }
}

const actions = {
  getWidthAndHeight(context, index) {
    // 获取贴图比例缩放后的宽高
    let wnh = {}
    let img = new Image()
    img.src = context.state.tempDragTarget.resourceUrl
    let timer = setInterval(() => {
      if (wnh.width) {
        clearInterval(timer)
        context.commit('tabDragRealAdd', {
          wnh: wnh,
          index: index
        })
      }
      wnh.width = img.width
      wnh.height = img.height
    }, 40)
  },
  setTrackDraw(context, way) {
    // way: 是否对当前list的所有轨道进行绘制
    context.state.vm.$nextTick(() => {
      const state = context.state
      if (way) {
        for (let i = 0; i < state[state.list].length; i++) {
          context.commit('trackDraw', i)
        }
      } else {
        context.commit('trackDraw')
      }
    })
  },
  setAllTrackDraw(context, params) {
    const list = params.list
    const prefix = params.prefix
    context.state.vm.$nextTick(() => {
      const state = context.state
      for (let i = 0; i < list.length; i++) {
        const realList = state[list[i]]
        state.trackId = prefix[i] + 'Track'
        state.prefix = prefix[i]
        state.list = list[i]
        for (let j = 0; j < realList.length; j++) {
          context.commit('trackDraw', j)
        }
      }
    })
  },
  setTrackBlockSelect(context, params) {
    params.vm.$nextTick(() => {
      context.commit('trackBlockSelect', params)
    })
  },
  async setNextTrackBlock(context) {
    // 触发页面渲染及轨道显示更新
    await this.dispatch('setTrackDraw', false)
    // 选中下一个轨道块
    const state = context.state
    const index = state.selected.index
    const newIndex = index > 0 ? index - 1 : index
    const target = state.vm.$refs[state.trackId][state.selected.trackIndex].$refs[state.prefix + newIndex][0]
    this.commit('trackBlockSelect', {
      e: target,
      index: newIndex,
      trackIndex: state.selected.trackIndex,
      list: state.selected.type,
      vm: state.vm
    })
    // 判断playing-
    state.needPointerJudge.isNeed = true
    state.needPointerJudge.target = state.list
  },
  getUnreadMsgNum({ commit }) {
    return axios({
      method: 'get',
      url: 'api/dsp/message/getUnreadNum',
      headers: { token: service.state.token }
    }).then(res => {
      if (res.data.code === 0) {
        commit('SET_UNREAD_MSG_NUM', res.data.data)
      }
    })
  },
  setShowMessageTip({ commit }, isShow) {
    commit('SET_MESSAGE_TIP', isShow)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
